window.onload = function () {
  if (window.jQuery) {
    let $ = window.jQuery;
    const parent = document.querySelector('[data-location-container]');
    const qtySelector = document.querySelector('.product-form__action-wrapper [data-quantity-input]');

    if (parent) {
      const block = parent.innerHTML;
      document.querySelector('.product-loc__block').setAttribute('data-block', Date.now().toString());

      document.querySelector('[data-location-add]').addEventListener('click', function (e) {
        addBlock(e);
      })
      document.querySelector('[data-location-remove]').addEventListener('click', function (e) {
        removeBlock(e);
      })

      $('#park_name').on('select2:select', function (e) {
        changeValue();
        getImage(e.target.closest('[data-location-block]'));
        $(this).closest('.product-loc__input-wrapper').removeClass('is-error');
      })
      $('#location').on('focusout', function (e) {
        getImage(e.target.closest('[data-location-block]'));
      })
      $('#location').on('input', function (e) {
        changeValue();
        $(this).closest('.product-loc__input-wrapper').removeClass('is-error');
      })

      $('[data-location-preview]').on('click', () => {
        changeValue();
        if ($(window).width() <= 768) {
          $('html, body').animate({
            scrollTop: $('#product-container').offset().top - 120
          }, 1000);
        }
      })

      $(".product-loc__container .js-park-name").select2({
          matcher: function(params, data) {
            if ($.trim(params.term) === '') {
              return data;
            }

            const term = params.term.toLowerCase();
            const text = data.text.toLowerCase();

            if (text.startsWith(term)) {
              return data;
            }

            return null;
          }
        });

      changeValue();

      function addBlock(e) {
        const formEl = document.querySelector('[data-location-form]');
        parent.insertAdjacentHTML('beforeend', block);
        const addedBlock = parent.querySelector('[data-location-block]:last-of-type');
        const blockId = Date.now().toString();
        e.target.style.display = 'none';

        document.querySelectorAll('[data-location-remove]').forEach(function (item) {
          item.style.display = 'block';
        })
        addedBlock.querySelector('.js-date-input').setAttribute('id', 'date-' + blockId);
        addedBlock.querySelector('.js-park-name').setAttribute('id', 'park_name-' + blockId);
        addedBlock.querySelector('.js-location-input').setAttribute('id', 'location-' + blockId);
        addedBlock.setAttribute('data-block', blockId);

        $('[data-location-block]:last-of-type .js-park-name').select2({
          matcher: function(params, data) {
            if ($.trim(params.term) === '') {
              return data;
            }

            const term = params.term.toLowerCase();
            const text = data.text.toLowerCase();

            if (text.startsWith(term)) {
              return data;
            }

            return null;
          }
        });

        const dateInput =  $('[data-location-block]:last-of-type .js-date-input');
        dateInput.mask('00/00/0000',{
          placeholder: "01/02/2024",
          clearIfNotMatch: false
        })
        dateInput.datepicker({
          dateFormat: 'mm/dd/yy',
          onSelect: function () {
            getImage($(this).closest('[data-location-block]'));
            changeValue();
            $(this).trigger('focus');
            $(this).closest('.product-loc__input-wrapper').removeClass('is-error');
          }
        })
        dateInput.on('focusout', function (e) {
          changeValue();
          getImage($(this).closest('[data-location-block]'));
          $(this).closest('.product-loc__input-wrapper').removeClass('is-error');
        })
        dateInput.on('focus', function (e) {
          const wrapper = dateInput.closest('.product-loc__input-wrapper')
          wrapper.find('.js-date-required').hide();
          wrapper.find('.js-product-loc-error').hide();
          wrapper.removeClass('is-error');
        })
        addedBlock.querySelector('[data-location-add]').addEventListener('click', function (e) {
          addBlock(e);
        })
        addedBlock.querySelector('[data-location-remove]').addEventListener('click', function (e) {
          removeBlock(e);
        })
        $('#park_name-' + blockId).on('select2:select', function () {
          getImage(addedBlock);
          changeValue();
          $(this).closest('.product-loc__input-wrapper').removeClass('is-error');
        })
        $('#location-' + blockId).on('focusout', function (e) {
          getImage(addedBlock);
        })
        $('#location-' + blockId).on('input', function (e) {
          changeValue();
          e.target.closest('.product-loc__input-wrapper').classList.remove('is-error');
        })
        $(`[data-block="${blockId}"]`).find('[data-location-preview]').on('click', () => {
          changeValue();
          if ($(window).width() <= 768) {
            $('html, body').animate({
              scrollTop: $('#product-container').offset().top - 120
            }, 1000);
          }
        })
        changeValue();
        //qtySelector.value = +qtySelector.value + 1;
      }

      function removeBlock(e) {
        const element = e.target.closest('[data-location-block]');
        const elList = document.querySelectorAll('[data-location-block]');
        const numberValue = element.getAttribute('data-block')
        if (elList.length > 1) {
          element.remove();
          const newElList = document.querySelectorAll('[data-location-block]');
          //qtySelector.value = +qtySelector.value - 1;
          if (newElList.length === 1) {
            document.querySelector('[data-location-remove]').style.display = 'none';
          }
        }
        if (document.querySelector('[data-block-image="' + numberValue + '"]')) {
          document.querySelector('[data-block-image="' + numberValue + '"]').remove();
        }
        const lastBlock = parent.querySelector('[data-location-block]:last-of-type');
        lastBlock.querySelector('[data-location-add]').style.display = 'block';
      }
    }

    function changeValue() {
      const blockList = document.querySelectorAll('[data-location-block]');
      blockList.forEach(function (item, index) {
        const propertiesInput = item.querySelector('.js-properties-input');
        const selects = item.querySelectorAll('.options-selection__input-select');
        const inputs = item.querySelectorAll('.js-input');
        const imageId = item.getAttribute('data-block');
        const imgSrc = document.querySelector('[data-block-image="' + imageId + '"]') ? document.querySelector('[data-block-image="' + imageId + '"]').getAttribute('src') : '';
        const inputValue = [];
        const dateInput = item.querySelector('.js-date-input');
        const dateValue = dateInput.value;
        if (!dateValue) {
          return;
        }

        if (blockList.length > 1) {
          propertiesInput.setAttribute('name', 'properties[Location' + (index + 1) + ']');
        } else {
          propertiesInput.setAttribute('name', 'properties[Location]');
        }
        selects.forEach(function (select) {
          inputValue.push(select.value);
        })

        inputs.forEach(function (input) {
          inputValue.push(input.value);
        })
        propertiesInput.value = inputValue.join(' - ');
        getToken(`${inputValue[0].trim()}${inputValue[2].trim()}${inputValue[1].trim()}e264bdc14a951c2be8febef80066134e`).then((token) => {
          propertiesInput.setAttribute('data-key', token);
        });
        let url = new URL(`https://en-mw.mtnhauslabs.com/sticker/generate?park=${encodeURIComponent(inputValue[0].trim())}`);
        if (inputValue[1].length > 0) {
          url.searchParams.set('date', `${inputValue[1].trim()}`);
        }
        if (inputValue[2].length > 0) {
          url.searchParams.set('location', `${inputValue[2].trim()}`);
        }
        propertiesInput.setAttribute('data-property-image', url.href);
      })
    }

    function getImage(parentBlock) {
      const locationVal = $(parentBlock).find('.js-location-input')[0].value;
      const parkVal = $(parentBlock).find('.js-park-name')[0].value;
      const dateVal = $(parentBlock).find('.js-date-input')[0].value;
      const parentBlockValue = $(parentBlock).attr('data-block');
      const imgGallery = $('[data-product-gallery]');

      if (parkVal.length > 0) {
        let url = new URL(`https://en-mw.mtnhauslabs.com/sticker/generate?park=${encodeURIComponent(parkVal)}`);
        if(locationVal.length > 0) {
          url.searchParams.set('location', `${locationVal}`);
        }
        if (dateVal.length > 0) {
          url.searchParams.set('date', `${dateVal}`);
        }
        $('.product-gallery--viewer').hide();

        if ($('[data-block-image="' + parentBlockValue + '"]').length > 0) {
          $('[data-block-image="' + parentBlockValue + '"]').attr('src', url.href);
        } else {
          if ($('[data-block-image]').length > 0) {
            $('[data-block-image]:last').after(`<img src="${url.href}" alt="${parkVal}" data-block-image="${parentBlockValue}" class="product-gallery_stamp" /> `);
          } else {
            imgGallery.append(`<img src="${url.href}" alt="${parkVal}" data-block-image="${parentBlockValue}" class="product-gallery_stamp"/> `);
          }
        }
      }
    }

    function removeImage(element) {
      const parentBlock = element.closest('[data-location-block]')
      const imageId = parentBlock.getAttribute('data-block');
      document.querySelector('[data-block-image="'+imageId+'"]') && document.querySelector('[data-block-image="'+imageId+'"]').remove();
    }

    async function getToken(message) {
      const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
      const hashBuffer = await crypto.subtle.digest("SHA-256", msgUint8); // hash the message
      const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
      const hashHex = hashArray
        .map((b) => b.toString(16).padStart(2, "0"))
        .join(""); // convert bytes to hex string
      return hashHex;
    }

    $(function () {
      const dateField = $("#date");
      dateField.mask('00/00/0000',{
        placeholder: "01/02/2024",
        clearIfNotMatch: false
      });
      dateField.datepicker({
        dateFormat: 'mm/dd/yy',
        onSelect: function () {
          getImage($(this).closest('[data-location-block]'));
          changeValue();
          $(this).trigger('focus');
          $(this).closest('.product-loc__input-wrapper').removeClass('is-error');
        }
      })
      dateField.on('focusout', function (e) {
        $(this).closest('.product-loc__input-wrapper').removeClass('is-error');
        getImage($(this).closest('[data-location-block]'));
        changeValue();
      })
      dateField.on('focus', function (e) {
        const wrapper = dateField.closest('.product-loc__input-wrapper')
        wrapper.find('.js-date-required').hide();
        wrapper.find('.js-product-loc-error').hide();
        wrapper.removeClass('is-error');
      })
    });
  }
}


